import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog: Gefundene Wiederaufnahmen in die Vorderseite übernehmen oder abbrechen.
 */
function WiederaufnahmenDialog({ open, pendingWiederaufnahmen, onApply, onCancel }) {
  const { t } = useTranslation();
  if (!open || !pendingWiederaufnahmen?.length) return null;

  const count = pendingWiederaufnahmen.length;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
        <h2>{t('dialog.wiederaufnahmen.title')}</h2>
        <p>{t('dialog.wiederaufnahmen.message', { count })}</p>
        <div style={{ maxHeight: '300px', overflowY: 'auto', margin: '20px 0', border: '1px solid #e1e4e8', borderRadius: '4px', padding: '10px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e1e4e8' }}>
                <th style={{ padding: '8px', textAlign: 'left' }}>{t('dialog.wiederaufnahmen.wa_nr')}</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>{t('dialog.wiederaufnahmen.datum')}</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>{t('dialog.wiederaufnahmen.beginn')}</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>{t('dialog.wiederaufnahmen.ende')}</th>
              </tr>
            </thead>
            <tbody>
              {pendingWiederaufnahmen.map((w) => (
                <tr key={w.nummer} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '8px' }}><strong>{w.nummer}</strong></td>
                  <td style={{ padding: '8px' }}>{w.datum}</td>
                  <td style={{ padding: '8px' }}>{w.beginnzeit || '-'}</td>
                  <td style={{ padding: '8px' }}>{w.endzeit || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={{ fontSize: '0.9rem', color: '#666' }}>
          {t('dialog.wiederaufnahmen.hint').split('\n').map((line, i) => (
            <React.Fragment key={i}>{line}{i === 0 ? <br /> : null}</React.Fragment>
          ))}
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button onClick={onCancel} type="button" style={{ padding: '10px 20px' }}>
            {t('dialog.cancel')}
          </button>
          <button
            onClick={onApply}
            type="button"
            style={{
              backgroundColor: '#0366d6',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            {t('dialog.wiederaufnahmen.apply')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WiederaufnahmenDialog;
